
import { defineComponent, onBeforeMount, onMounted, ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { isDocPage, version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import AdminMenuConfig from "@/core/config/AdminMenuConfig";
import MainMenuConfig from "@/core/config/MainMenuConfig";
import { useStore } from "vuex";

import firebase from 'firebase'


export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const store = useStore();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);
    const isAdmin = ref('User')
    
    
    onMounted(() => {
        if (store.getters.currentUser.uid == 'tAWYCnf4mgcpZpG9Emr2LeNgY9p2')
         isAdmin.value = 'Admin'
      else
        isAdmin.value = 'User'
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });
    
    const translate = text => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = match => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      isAdmin,
      hasActiveChildren,
      isDocPage,
      AdminMenuConfig,
      MainMenuConfig,
      asideMenuIcons,
      version,
      translate
    };
  }
});
